import { useState } from 'react';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { Copy, RefreshCw, Type } from 'lucide-react';
import { toast } from 'sonner';

const WordCounterTool = () => {
  const [text, setText] = useState('');

  const stats = {
    characters: text.length,
    charactersNoSpaces: text.replace(/\s/g, '').length,
    words: text.trim() ? text.trim().split(/\s+/).length : 0,
    sentences: text.split(/[.!?]+/).filter(s => s.trim()).length,
    paragraphs: text.split(/\n\n+/).filter(p => p.trim()).length,
    lines: text.split('\n').length,
    readingTime: Math.ceil((text.trim() ? text.trim().split(/\s+/).length : 0) / 200),
    speakingTime: Math.ceil((text.trim() ? text.trim().split(/\s+/).length : 0) / 150),
  };

  const copyStats = () => {
    const statsText = `Words: ${stats.words}\nCharacters: ${stats.characters}\nCharacters (no spaces): ${stats.charactersNoSpaces}\nSentences: ${stats.sentences}\nParagraphs: ${stats.paragraphs}\nReading Time: ${stats.readingTime} min`;
    navigator.clipboard.writeText(statsText);
    toast.success('Stats copied!');
  };

  return (
    <div className="space-y-6" data-testid="word-counter-tool">
      <div className="grid lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <Textarea
            placeholder="Type or paste your text here..."
            value={text}
            onChange={(e) => setText(e.target.value)}
            className="min-h-[300px] font-mono text-sm bg-muted/50"
            data-testid="word-counter-input"
          />
        </div>
        <div className="space-y-4">
          <div className="p-4 rounded-xl bg-muted/30 border border-border">
            <h3 className="font-semibold mb-4 flex items-center gap-2">
              <Type className="w-4 h-4 text-primary" />
              Statistics
            </h3>
            <div className="space-y-3">
              <div className="flex justify-between">
                <span className="text-muted-foreground">Words</span>
                <span className="font-mono font-semibold text-primary">{stats.words.toLocaleString()}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-muted-foreground">Characters</span>
                <span className="font-mono">{stats.characters.toLocaleString()}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-muted-foreground">Characters (no spaces)</span>
                <span className="font-mono">{stats.charactersNoSpaces.toLocaleString()}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-muted-foreground">Sentences</span>
                <span className="font-mono">{stats.sentences}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-muted-foreground">Paragraphs</span>
                <span className="font-mono">{stats.paragraphs}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-muted-foreground">Lines</span>
                <span className="font-mono">{stats.lines}</span>
              </div>
              <hr className="border-border" />
              <div className="flex justify-between">
                <span className="text-muted-foreground">Reading Time</span>
                <span className="font-mono">{stats.readingTime} min</span>
              </div>
              <div className="flex justify-between">
                <span className="text-muted-foreground">Speaking Time</span>
                <span className="font-mono">{stats.speakingTime} min</span>
              </div>
            </div>
          </div>
          <div className="flex gap-2">
            <Button onClick={copyStats} variant="outline" className="flex-1">
              <Copy className="w-4 h-4 mr-2" /> Copy Stats
            </Button>
            <Button onClick={() => setText('')} variant="outline">
              <RefreshCw className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WordCounterTool;
